import { render, staticRenderFns } from "./PayType.vue?vue&type=template&id=0b5608ad&scoped=true&"
import script from "./PayType.vue?vue&type=script&lang=js&"
export * from "./PayType.vue?vue&type=script&lang=js&"
import style0 from "./PayType.vue?vue&type=style&index=0&id=0b5608ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5608ad",
  null
  
)

export default component.exports